import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject, takeUntil} from 'rxjs';
import {FuseMediaWatcherService} from 'fuseui';
import {FuseNavigationService, FuseVerticalNavigationComponent} from 'fuseui';
import {Navigation} from '../../../../../../../../apps/fuse/src/app/core/navigation/navigation.types';
import {NavigationService} from '../../../../../../../../apps/fuse/src/app/core/navigation/navigation.service';
import {UserService} from '../../../../../../../../apps/fuse/src/app/core/user/user.service';
import {UserResource} from 'hr';
import {AuthService} from '../../../../auth/auth.service';


@Component({
    selector: 'classy-layout',
    templateUrl: './classy.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {

    isScreenSmall?: boolean;
    navigation?: Navigation;
    user?: UserResource;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    isAdmin = false;

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _userService: UserService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _authService: AuthService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        // Subscribe to the user service
        this._userService.user$
            .pipe((takeUntil(this._unsubscribeAll)))
            .subscribe((user: UserResource) => {
                this.user = user;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });

        this._authService.profile().subscribe((response: any) => {
            const roles = response.roles;
            roles.forEach((role: any) => {
                if (role.name === 'role.admin' || role.name === 'role.superadmin') {
                    this.isAdmin = true;
                }
            });
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    getNavigation() {
        if (this.navigation) {
            return this.isAdmin ? this.navigation.default : this.navigation.defaultNotAdmin;
        } else {
            return null;
        }
    }

    getHorizontalNavigation() {
        if (this.navigation) {
            return this.isAdmin ? this.navigation.horizontal : this.navigation.horizontalNotAdmin;
        } else {
            return null;
        }
    }
}
